module.exports = __webpack_public_path__ + "img/banner_iv1.fe21a2be.png";